import * as React from "react";
import { Provider, connect } from "react-redux";
import { store } from "./redux/store";
import { BookmarkService } from "../../services/bookmarkService";
import IBookmarkAppProps from "../hero-bookmarks/interfaces/bookmarkAppProps";
import BookmarkCategories from "../hero-bookmarks/bookmarkCategories";
import { render } from "../../common/reactUtils";

class EducationApp extends React.Component<IBookmarkAppProps, { bookmarks: any[] }> {
    bookmarkService: BookmarkService;

    constructor(props: IBookmarkAppProps) {
        super(props);
        this.bookmarkService = new BookmarkService();
        this.state = {
            bookmarks: [], // Initialize with an empty array
        };
        this.loadData = this.loadData.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);

        window.addEventListener("OnPinnedBookmarkChanged", () => {
            this.loadData();
        })
    }

    loadData() {
        // Fetch the selected bookmarks
        this.bookmarkService.getSelectedBookmarks(
            (data) => {
                this.setState({ bookmarks: data.courses }); // Update state with fetched data
            },
            () => {
                console.error("Failed to fetch pinned notes");
            }
        );
    }

    componentDidMount(): void {
        this.loadData();
    }
    handleDragEnd(result: any) {
        const { source, destination } = result;

        if (!destination) {
            return;
        }

        const reorderedBookmarks = Array.from(this.state.bookmarks);
        const [removed] = reorderedBookmarks.splice(source.index, 1);
        reorderedBookmarks.splice(destination.index, 0, removed);

        const bookmarkIds = reorderedBookmarks.map((bookmark) => bookmark.id);

        this.setState({ bookmarks: reorderedBookmarks }, () => {
            this.bookmarkService.updateSortOrder(
                bookmarkIds,
                (response) => {
                    console.log("Sort order updated successfully:", response);
                },
                (error) => {
                    console.error("Failed to update sort order:", error);
                }
            );
        });
    }

    render() {
        return (
            <React.Fragment>
                <div
                    id="hero-educations"
                    className="notifications__list-wrapper notifications__list-wrapper--flex pinned2"
                >
                    
                    <BookmarkCategories
                            items={this.state.bookmarks}
                            onDragEnd={this.handleDragEnd} // Pass the handler to BookmarkCategories
                        />

                </div>
            </React.Fragment>
        );
    }
}

const ConnectedApp = connect(null, null)(EducationApp);

export const initialize = () => {
    render(
        <Provider store={store}>
            <ConnectedApp />
        </Provider>,
        "#js-react-myeducations-app"
    );
};
